import {genericLoad} from '../helpers/reduxHelpers';
import {settingsActionTypes as actions} from './actionTypes';
import {formValidation, handleError} from '../helpers';
import {updatePortalSetting} from './portalActions';
import {success as successAlert} from './alertActions';

export const getSettings = () => dispatch => {
  genericLoad({
    dispatch,
    field: 'settings',
    stateField: 'settings',
    title: 'settings',
    type: actions.SETTINGS,
    url: '/settingitems',
    useMAPI: true,
  });
};

export const savePaymentSettings = settings => async dispatch => {
  const formObject = formValidation.setupFormBody(settings);
  if (formObject.hasError) {
    handleError(formObject.errorMessage, null, dispatch);
    return false;
  }
  let success = true;
  if (settings.autoCloseStatus.isDirty) {
    success &= await dispatch(
      updatePortalSetting('AutoCloseTicket', settings.autoCloseStatus.value),
    );
  }
  if (settings.terms.isDirty) {
    success &= await dispatch(
      updatePortalSetting('Payment Terms', settings.terms.value),
    );
  }
  if (success) {
    dispatch(successAlert('Saved!'));
  }
  return success;
};



// WEBPACK FOOTER //
// ./src/actions/settingsActions.js